import Container from '@/components/@base/container';
import localization from '@/constant/localization';
import { Text } from '@/components/@base/typography';
import Button from '@/components/@base/button';
import { useTimer } from 'react-timer-hook';
import { useEffect } from 'react';
import { addToTime } from '@/lib/date';
import FontIcon from '@/components/@base/font-icon';

const PaymentTimeExpiration = () => {
  const { seconds, restart } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => {
      if (seconds === 1) handleRedirect()
    },
  });
  useEffect(() => {
    const time = addToTime(new Date(), 6, { unit: 'SECONDS' });
    restart(time);
  }, []);
  const handleRedirect = () => {
    if(localStorage.getItem('merchantRedirectURL')) location.replace(localStorage.getItem('merchantRedirectURL')!)
  }
  return (
    <Container center className='w-full flex-col p-4  pt-8'>
      <FontIcon icon="icon-face-sad" className='text-3xl text-red bg-red-50 rounded-full h-[56px] w-[56px] flex items-center justify-center mb-6'/>
      <Text semiBold className='text-xl text-grayLight-1000 dark:text-grayLight-0 mt-2 mb-3'>{localization.paymentIsExpired}</Text>
      <Text className='text-md text-grayLight-850 dark:text-grayLight-500 text-center mb-8'>{localization.paymentIsExpiredCaption}</Text>
      <Button className='w-full h-14 rounded-full text-md' onClick={handleRedirect}>{localization.returnToReceivingSite(seconds)}</Button>
    </Container>
  )
}
export default PaymentTimeExpiration